export const getShortcut = (id, shortcuts) =>
  shortcuts.find((shortcut) => shortcut.id === id);

export const getShortcutIndex = (id, shortcuts) =>
  shortcuts.findIndex((shortcut) => shortcut.id === id);
